import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getCommissionsState(statusIdToFilter = []) {
    const response = await axios.get(`${REACT_APP_API}/states?class=CommissionPolicies&per_page=-1`);
    const allStates = []
    response.data.data.forEach(state => {
        if (statusIdToFilter.length && statusIdToFilter.some(id => id === state.id)) return;
        let stateIndex = allStates.findIndex(s => s.label === state.name) 
        if(stateIndex >= 0){
            allStates[stateIndex].value = `${allStates[stateIndex].value},${state.id}`
        } else {
            allStates.push({
                label:state?.name,
                value:state?.id
            })
        }
    })
    return allStates;
}